module.exports = new __parcel__URL__("DatabaseGAOnboarding.fdc4cc79.svg").toString();